// TODO : Import these from SDK (SCAL-232192)

import { DrilldownParams, UpdateFiltersParams } from '@thoughtspot/embed-util';

// These are the contracts for the Ui passthrough methods available for Ui Passthrough interface fro SDK
export enum UiPassthroughEvent {
    addVizToPinboard = 'addVizToPinboard',
    saveAnswer = 'saveAnswer',
    getPinboardTabInfo = 'getPinboardTabInfo',
    getAvailableUiPassthroughs = 'getAvailableUiPassthroughs',
    getAnswerPageConfig = 'getAnswerPageConfig',
    getPinboardPageConfig = 'getPinboardPageConfig',
    getUnsavedAnswerTML = 'getUnsavedAnswerTML',
    makeACopy = 'makeACopy',
    getAnswerSession = 'getAnswerSession',
    getFilters = 'getFilters',
    getIframeUrl = 'getIframeUrl',
    getParameters = 'getParameters',
    getTML = 'getTML',
    getTabs = 'getTabs',
    getExportRequestForCurrentPinboard = 'getExportRequestForCurrentPinboard',
    UiPassthroughEventNotFound = 'UiPassthroughEventNotFound',
    drillDown = 'drillDown',
    updateFilters = 'updateFilters',
}

export type UiPassthroughContractBase = {
    [UiPassthroughEvent.addVizToPinboard]: {
        request: {
            vizId?: string;
            newVizName: string;
            newVizDescription?: string;
            pinboardId?: string;
            tabId?: string;
            newPinboardName?: string;
            newTabName?: string;
            pinFromStore?: boolean;
        };
        response: {
            pinboardId: string;
            tabId: string;
            vizId: string;
            errors?: any;
        };
    };
    [UiPassthroughEvent.saveAnswer]: {
        request: {
            name: string;
            description: string;
            vizId: string;
            isDiscoverable?: boolean;
        };
        response: {
            saveResponse: {
                data?: {
                    Answer__save: {
                        answer: {
                            id: string;
                        };
                    };
                };
                errors?: any;
            };
            shareResponse?: {
                Share?: boolean;
                errors?: any;
            };
        };
    };
    [UiPassthroughEvent.getPinboardTabInfo]: {
        request: any;
        response: any;
    };
    [UiPassthroughEvent.getAvailableUiPassthroughs]: {
        request: any;
        response: {
            keys: string[];
        };
    };
    [UiPassthroughEvent.getAnswerPageConfig]: {
        request: {
            vizId?: string;
        };
        response: any;
    };
    [UiPassthroughEvent.getPinboardPageConfig]: {
        request: any;
        response: any;
    };
    [UiPassthroughEvent.UiPassthroughEventNotFound]: {
        request: any;
        response: any;
    };
    [UiPassthroughEvent.getUnsavedAnswerTML]: {
        request: {
            vizId?: string;
            sessionId?: string;
        };
        response: any;
    };
    [UiPassthroughEvent.makeACopy]: {
        request: {
            name: string;
            description?: string;
            dynamicName?: string;
            dynamicDescription?: string;
            vizId?: string; // If provided, copy specific viz; otherwise copy entire liveboard
        };
        response: {
            newLiveboardId?: string; // For liveboard copy
            newAnswerId?: string; // For viz copy
            newVizId?: string; // For viz copy
            genNo?: string;
            errors?: any;
        };
    };
    [UiPassthroughEvent.getAnswerSession]: {
        request: {
            vizId?: string;
        };
        response: {
            session: any;
            embedAnswerData?: any;
        };
    };
    [UiPassthroughEvent.getFilters]: {
        request: {
            vizId?: string;
        };
        response: {
            liveboardFilters?: any[];
            runtimeFilters?: any[];
            answerFilters?: any[];
        };
    };
    [UiPassthroughEvent.getIframeUrl]: {
        request: any;
        response: {
            iframeUrl: string;
        };
    };
    [UiPassthroughEvent.getParameters]: {
        request: any;
        response: {
            parameters: any[];
        };
    };
    [UiPassthroughEvent.getTML]: {
        request: {
            vizId?: string;
            includeNonExecutedSearchTokens?: boolean;
        };
        response: any;
    };
    [UiPassthroughEvent.getTabs]: {
        request: any;
        response: {
            orderedTabIds: string[];
            numberOfTabs: number;
            Tabs: any[];
        };
    };
    [UiPassthroughEvent.getExportRequestForCurrentPinboard]: {
        request: any;
        response: {
            data: { v2Content: string };
            type: UiPassthroughEvent.getExportRequestForCurrentPinboard;
        };
    };
    [UiPassthroughEvent.drillDown]: {
        request: DrilldownParams;
        response: void;
    };
    [UiPassthroughEvent.updateFilters]: {
        request: UpdateFiltersParams;
        response: void;
    };
};

export enum ContextType {
    LIVEBOARD = 'liveboard',
    SPOTTER = 'spotter',
    ANSWER = 'answer',
    SEARCH = 'search',
}
